import { DRAG_START, TARGET, DRAG, AUTO, DRAG_END, Cursors } from '../../constants.js';
import { canDrag } from './canDrag.js';
import { Shape } from '../../dom/Shape.js';

class ConnectionTool {
    constructor(toolService) {
        this.toolService = toolService;
        this.type = 'ConnectionTool';
    }
    tryActivate() {
        return this.toolService._hoveredConnector;
    }
    start(p, meta) {
        const toolService = this.toolService, diagram = toolService.diagram, connector = toolService._hoveredConnector, connection = diagram._createConnection({}, connector._c, p);
        if (canDrag(connection) && !diagram.trigger(DRAG_START, { shapes: [], connections: [connection], connectionHandle: TARGET }) && diagram._addConnection(connection)) {
            toolService._connectionManipulation(connection, connector._c.shape, true);
            toolService._removeHover();
            toolService.selectSingle(toolService.activeConnection, meta);
            if (meta.type === 'touchmove') {
                diagram._cachedTouchTarget = connector.visual;
            }
        }
        else {
            connection.source(null);
            toolService.end(p);
        }
    }
    move(p) {
        const toolService = this.toolService;
        const connection = toolService.activeConnection;
        connection.target(p);
        toolService.diagram.trigger(DRAG, { shapes: [], connections: [connection], connectionHandle: TARGET });
        return true;
    }
    end(p) {
        const toolService = this.toolService, diagram = toolService.diagram, connection = toolService.activeConnection, hoveredItem = toolService.hoveredItem, connector = toolService._hoveredConnector, cachedTouchTarget = diagram._cachedTouchTarget;
        let target;
        if (!connection) {
            return;
        }
        if (connector && connector._c !== connection.sourceConnector) {
            target = connector._c;
        }
        else if (hoveredItem && hoveredItem instanceof Shape) {
            target = hoveredItem.getConnector(AUTO) || hoveredItem.getConnector(p);
        }
        else {
            target = p;
        }
        connection.target(target);
        if (!diagram.trigger(DRAG_END, { shapes: [], connections: [connection], connectionHandle: TARGET })) {
            connection.updateModel();
            diagram._syncConnectionChanges();
        }
        else {
            diagram.remove(connection, false);
            diagram.undoRedoService.pop();
        }
        toolService._connectionManipulation();
        if (cachedTouchTarget) {
            diagram._connectorsAdorner.visual.remove(cachedTouchTarget);
            diagram._cachedTouchTarget = null;
        }
    }
    getCursor() {
        return Cursors.arrow;
    }
}

export { ConnectionTool };
